module.exports = __webpack_public_path__ + "static/img/1.7733ee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/laboratory/1.jpg
// module id = hHrJ
// module chunks = 1